import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.82616 1.33337C11.4062 1.33337 14.3182 4.24537 14.3182 7.82537C14.3182 9.51441 13.67 11.0549 12.6093 12.211L14.6964 14.2938C14.8918 14.4892 14.8924 14.8052 14.6971 15.0005C14.5998 15.0992 14.4711 15.1478 14.3431 15.1478C14.2158 15.1478 14.0878 15.0992 13.9898 15.0018L11.8774 12.8954C10.7662 13.7853 9.35728 14.318 7.82616 14.318C4.24616 14.318 1.3335 11.4054 1.3335 7.82537C1.3335 4.24537 4.24616 1.33337 7.82616 1.33337ZM7.82616 2.33337C4.7975 2.33337 2.3335 4.79671 2.3335 7.82537C2.3335 10.854 4.7975 13.318 7.82616 13.318C10.8542 13.318 13.3182 10.854 13.3182 7.82537C13.3182 4.79671 10.8542 2.33337 7.82616 2.33337Z",
      fill: __props.color || 'black'
    }, null, 8, _hoisted_2)
  ]))
}
}

})